import * as React from "react";
const ElchemyLogoMobileSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#040919"
      d="M4.18 9.97v3.204h5.951v2.217H1.59V2.35h8.357V4.57H4.18v3.184h5.492V9.97H4.18ZM24.718 12.988c-.662 1.546-2.04 2.589-4.152 2.589-3.049 0-4.574-1.937-4.574-4.843 0-2.906 1.525-4.843 4.574-4.843 1.965 0 3.325.913 4.023 2.235l-2.24 1.36c-.442-.913-1.103-1.38-1.783-1.38-1.34 0-1.984 1.026-1.984 2.627 0 1.602.643 2.627 1.984 2.627.698 0 1.433-.485 1.8-1.434l2.352 1.062ZM28.54 15.391h-2.59V1.793h2.59v5.16c.697-.727 1.469-1.062 2.553-1.062 1.836 0 2.92 1.136 2.92 3.52v5.98h-2.59V9.468c0-.95-.514-1.36-1.286-1.36-.955 0-1.598.819-1.598 2.924v4.359ZM14.563 11.032v4.359h-2.59V1.793h2.59v9.24ZM44.083 14.664c-1.268.615-2.498.913-3.637.913-3.123 0-5.051-1.844-5.051-4.843 0-2.906 1.543-4.843 4.573-4.843 2.866 0 4.28 1.862 4.28 4.433v1.379h-6.172c.258 1.043 1.01 1.657 2.425 1.657.772 0 1.69-.242 2.756-.763l.826 2.067ZM38.13 9.561h3.509c-.074-1.007-.754-1.454-1.672-1.454-.973 0-1.58.54-1.837 1.454ZM52.828 7.367c.642-.95 1.653-1.453 2.792-1.453 1.984 0 3.38 1.08 3.38 3.316v6.184h-2.59V9.192c0-.745-.588-1.062-1.084-1.062-1.084 0-1.635.858-1.635 2.385v4.899h-2.59v-6.11c0-.8-.57-1.173-1.157-1.173-.918 0-1.561.857-1.561 2.403v4.88h-2.59V6.1h2.59v.932c.496-.764 1.102-1.118 2.002-1.118 1.084 0 1.983.522 2.443 1.453ZM65.907 14.555l-3.455 8.085H59.66l3.307-8.212-3.307-8.326h2.81l3.437 8.453Z"
    />
    <path
      fill="#ee4238"
      d="M64.703 11.558 66.701 6.1h2.773l-2.318 5.462-2.453-.004Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={64.703}
        x2={69.474}
        y1={8.83}
        y2={8.83}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F15B2A" />
        <stop offset={1} stopColor="#EF4137" />
      </linearGradient>
    </defs>
  </svg>
);
export default ElchemyLogoMobileSVG;
